const ErrorFallback = ({ error, resetError }) => {
  // Call resetError() to reset the error boundary and retry the render.

  return (
    <div
      role="alert"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          fontFamily: "var(--monospace)",
          lineHeight: 1.5,
          maxWidth: "80vw",
          color: "var(--window-color)",
          boxSizing: "border-box",
          margin: "30px auto",
          padding: "2.5vh 4vw",
          position: "relative",
          background: "var(--window-background)",
          borderRadius: "6px 6px 8px 8px",
          boxShadow:
            "0 19px 38px rgba(0, 0, 0, 0.30), 0 15px 12px rgba(0, 0, 0, 0.22)",
          overflow: "hidden",
          borderTop: "8px solid var(--red)",
          direction: "ltr",
          textAlign: "left",
        }}
      >
        <p style={{ fontSize: "16px", fontWeight: "bold" }}>
          Something went wrong:
        </p>
        <pre style={{ color: "red" }}>{error.message}</pre>
        {error.stack && (
          <>
            <summary style={{ fontSize: "16px", fontWeight: "bold" }}>
              Stack trace
            </summary>
            <pre style={{ color: "red", fontSize: "12px" }}>{error.stack}</pre>
          </>
        )}
      </div>
    </div>
  );
};

export default ErrorFallback;
